import { QueryClient } from "@tanstack/query-core";
import { base64url } from "jose";
const queryClient = new QueryClient();
const browserOrNode = ()=>{
    const isBrowser = 'undefined' != typeof window && void 0 !== window.document;
    const isNode = 'undefined' != typeof process && null != process.versions && null != process.versions.node;
    return {
        isBrowser,
        isNode
    };
};
const stripUndefined = (params)=>Object.keys(params).filter((k)=>void 0 !== params[k]).reduce((acc, key)=>({
            ...acc,
            [key]: params[key]
        }), {});
const createQueryParams = ({ clientId: client_id, ...params })=>new URLSearchParams(stripUndefined({
        client_id,
        ...params
    })).toString();
const encode = (value)=>btoa(value);
const decode = (value)=>atob(value);
const urlEncodeB64 = (input)=>{
    let unencoded;
    unencoded = 'string' == typeof input ? new TextEncoder().encode(input) : new Uint8Array(input);
    return base64url.encode(unencoded);
};
const urlDecodeB64 = (input)=>new TextDecoder().decode(base64url.decode(input));
const getPurinaOrgId = (domain)=>{
    const PURINA_ORG_IDS = {
        dev: domain.includes('auth-dev.purina.com') ? 'org_WRTgeeXepfpTMmbU' : 'org_sSXyKX0ifXRizERr',
        qa: 'org_sSXyKX0ifXRizERr',
        prod: 'org_ouXJTBohAyhioATD'
    };
    if (domain.includes('auth-dev.purina.com')) return PURINA_ORG_IDS['dev'];
    if (domain.includes('auth-ts.purina.com')) return PURINA_ORG_IDS['qa'];
    if (domain.includes('auth.purina.com')) return PURINA_ORG_IDS['prod'];
};
const query = (key, callback, options = {})=>queryClient.getQueryCache().build(queryClient, {
        queryKey: key,
        queryFn: callback,
        ...options
    }).fetch();
const mutate = (key, callback, options = {})=>{
    const variables = {};
    return queryClient.getMutationCache().build(queryClient, {
        mutationKey: key,
        mutationFn: callback,
        ...options
    }).execute(variables);
};
export { browserOrNode, createQueryParams, decode, encode, getPurinaOrgId, mutate, query, queryClient, urlDecodeB64, urlEncodeB64 };
